// extracted by extract-css-chunks-webpack-plugin
module.exports = {"animation":"_2LIRhS","right-pillar":"_3LEXAm","middle-right":"xkZ4cU","middle-pillar":"_1Y8-tf","top-left":"_8gZHpo","left-pillar":"_2mJY-L","bottom-left":"kQtPBN"};